/**
 * @generated SignedSource<<4ba4eaacce81ae770c08d18ac93ecf34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4ForgeMenuItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4AppMenuItem">;
  readonly " $fragmentType": "Nav4ForgeMenuItem";
};
export type Nav4ForgeMenuItem$key = {
  readonly " $data"?: Nav4ForgeMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ForgeMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4ForgeMenuItem",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Nav4AppMenuItem"
    }
  ],
  "type": "JiraAppNavigationItem"
};

(node as any).hash = "e6f8d3ee567e6cd74addae3ad5622034";

export default node;
